<template>
  <el-main width="80%">
    <PrepostHomeSroDash
      ref="sroDash"
      :startedAt="startedAt"
      :finishedAt="finishedAt"
      :customer="customer"
      :services="services"
      @open="detail"
    />
    <PostSroMainHomeStatus :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
    <br />
    <PostSroMainHomeNotDelivered
      ref="notDelivered"
      :startedAt="startedAt"
      :finishedAt="finishedAt"
      :customer="customer"
      :services="services"
    />
    <!--PostSroMainTableHeader :total="total" @export="exportData" @fetch="fetch" /-->
  </el-main>
</template>
<script>
import PrepostHomeSroDash from "../../../../services/pre.post/components/PrepostHomeSroDash.vue";
import PostSroMainHomeStatus from "./PostSroMainHomeStatus.vue";
import PostSroMainHomeNotDelivered from "./PostSroMainHomeNotDelivered.vue";
import PostSroMainTableHeader from "./PostSroMainTableHeader.vue";
export default {
  name: "PostSroMainHome",
  props: ["startedAt", "finishedAt", "customer", "services"],
  components: {
    PrepostHomeSroDash,
    PostSroMainTableHeader,
    PostSroMainHomeStatus,
    PostSroMainHomeNotDelivered,
  },
  mounted() {
    if (this.$refs.sroDash) this.$refs.sroDash.fetch();
  },
  data() {
    return {
      tableData: [],
      total: 0,
      records: 50,
      page: 1,
    };
  },
  methods: {
    exportData(type) {},
    pagination(records, page) {
      this.records = records;
      this.page = page;
      this.fetch();
    },
    fetch() {
      if (this.$refs.sroDash) this.$refs.sroDash.fetch();
      this.$bus.$emit("fetch");
    },
    detail(status) {
      console.log("opem detail", status);
      this.$refs.notDelivered.detail(status);
    },
  },
};
</script>
